import { z } from 'zod';

type AccountSettingsSchemaProps = {
  required: string;
  invalidPhoneNumber: string;
};

export const getAccountSettingsSchema = (messages: AccountSettingsSchemaProps) =>
  z.object({
    firstName: z.string().min(1, { message: messages.required }),
    lastName: z.string().min(1, { message: messages.required }),
    phoneNumber: z
      .string()
      .optional()
      .refine((val) => !val || /^\+?[1-9]\d{1,14}$/.test(val), {
        message: messages.invalidPhoneNumber,
      }),
    avatar: z.instanceof(File).or(z.string()).optional().nullable(),
  });

export type AccountSettingsSchema = z.infer<ReturnType<typeof getAccountSettingsSchema>>;
